import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import userContext from "../Context/userContext";
import Cargando from "../Comun/Cargando";
import SinPermiso from "./SinPermiso";

// ══════════════════════════════════════════════════════
//  Ruta SOLO para el admin (/admin/* y la edición de recetas)
//  - Comprobando la sesión → «Cargando».
//  - Sin sesión → al login, que vuelve aquí después (state.redirectTo).
//  - Con sesión pero sin ser admin → «No tienes permiso…».
//  La API también lo comprueba (403): esto solo evita enseñar la página.
// ══════════════════════════════════════════════════════

const AdminRoute = ({ user, component }) => {
  const location = useLocation();
  const { cargandoSesion } = useContext(userContext);

  if (cargandoSesion) return <Cargando texto="Comprobando tu sesión…" />;

  if (!user) {
    const redirectTo = location.pathname + location.search + location.hash;
    return <Navigate to="/login" replace state={{ redirectTo }} />;
  }

  if (user.role !== "admin") return <SinPermiso />;

  return component;
};

export default AdminRoute;
